<template>
  <b-form-input
    ref="currencyAmountInput"
    @input="onInput"
    @keyup="onKeyup"
    @keypress.native="onKeypress"
    @focus.native="onFocus"
    @blur.native="onBlur"
    @paste.prevent
    :value="value"
    :maxlength="currencyMaxLength"
    :placeholder="placeholder"
    :class="className"
    :disabled="disabled"
    inputmode="numeric"
    pattern="[0-9]*"
    autocomplete="off"
  />
</template>

<script>
export default {
  props: ["value", "maxLength", "placeholder", "className", "disabled"],
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
    onKeyup(e) {
      if (!this.isNotNumeric(String.fromCharCode(e.keyCode)))
        this.$emit("keyup", e);
    },
    formatCurrency(value) {
      if (!value || value === ".") return 0;

      const fractionDigits = 2;

      return Number(
        parseFloat(value.toString().replace(",", "")).toFixed(fractionDigits)
      ).toLocaleString("en", {
        minimumFractionDigits: fractionDigits,
      });
    },
    isNotNumeric(input) {
      return /[^0-9.]/g.test(input);
    },
    onKeypress(e) {
      const period = 46;

      if (this.isNotNumeric(String.fromCharCode(e.keyCode))) e.preventDefault();
      if (e.keyCode === period) {
        if (e.target.value.includes(".")) e.preventDefault();
        else this.onInput(`${e.target.value}.`);
      }
    },
    onFocus() {
      if (this.$refs.currencyAmountInput.value)
        this.$emit(
          "input",
          this.$refs.currencyAmountInput.value.toString().replace(/,/g, "")
        );
    },
    onBlur() {
      if (this.$refs.currencyAmountInput.value)
        this.$emit(
          "input",
          this.formatCurrency(this.$refs.currencyAmountInput.value)
        );
    },
  },
  computed: {
    currencyMaxLength() {
      if (!this.value || !this.maxLength) return 524288;

      return this.value.toString().includes(".")
        ? parseInt(this.maxLength) + 3
        : this.maxLength;
    },
  },
};
</script>

